<nav class="navbar navbar-dark navbar-expand-md position-fixed w-100 d-flex justify-content-center">
  <div class="guest-container">
    <img src="../../../assets/images/tgi.png" alt="Logo" height="80" class="d-inline-block align-text-top logo-img py-2">
    <!-- <div class="fw-bolder ms-4 fs-3 text-white d-inline ff-brand">
      Avery Cloud
    </div> -->
  </div>
</nav>
